import React, { Component } from 'react';
import { Chat } from './chat/Chat'
import Pusher from 'pusher-js'
import { ThreadList } from './chat/ThreadList';
import { Layout } from './Layout';
import { ConfirmExistingCustomer } from './chat/ConfirmExistingCustomer';
import Loader from 'react-loader-advanced';
import './chat.min.css';
import '../css/custom.css';


// The legacy interaction API (BaseApiAddress) uses Newtonsoft PreserveReferencesHandling,
// which wraps arrays as { $id, $values: [...] }. Normalize to a plain array so callers can
// safely use .map/.length regardless of the response shape.
function toArray(data) {
    if (Array.isArray(data))
        return data;
    if (data && Array.isArray(data.$values))
        return data.$values;
    return [];
}

export class Home extends Component {
    static displayName = Home.name;

    constructor() {
        super()

        this.state = {
            user: JSON.parse(localStorage.getItem('user')),
            interactionThreadId: null,
            allThreads: [],
            filteredThreads: [],
            messageList: [],
            currentThread: null,
            loading: false,
            showConfirmExistingCustomer: false,
            confirmMemberID: '',
            confirmFirstName: '',
            confirmLastName: '',
            confirmCellphone: '',
            confirmCreatedDate: '',
        }


        this.sendMessage = this.sendMessage.bind(this);
        this.chooseThread = this.chooseThread.bind(this);
        this.addContact = this.addContact.bind(this);
        this.deleteChat = this.deleteChat.bind(this);
        this.editContact = this.editContact.bind(this);
        this.getContact = this.getContact.bind(this);
        this.createInteractionThread = this.createInteractionThread.bind(this);
        this.toggleConfirmCustomer = this.toggleConfirmCustomer.bind(this);
        this.confirmMember = this.confirmMember.bind(this);
        this.markThreadAsRead = this.markThreadAsRead.bind(this);

        this.hideThreadList = this.hideThreadList.bind(this);
        
    }

    componentWillMount() {

        //var isIframe = (this.props.location.state != undefined && this.props.location.state.isIframe != undefined && this.props.location.state.isIframe === true)

        //if (isIframe) {
        //    require('../css/iframe.css');
        //}



        //const query = new URLSearchParams(this.props.location.search);
        //var isIframe = query.get('i')
        //if (isIframe != undefined) {
        //    require('../css/iframe.css');
        //}
    }


    getConfig = async () => {
        var response = await fetch('api/Config/GetConfig')
        const json = await response.json();
        this.setState({
            baseApi: json.baseApiAddress,
            parentAppBaseUrl: json.parentAppBaseUrl,
            pusherKey: json.pusherKey,
            pusherCluster: json.pusherCluster
        });

    }
    componentDidMount() {

        this.getConfig().then(() => this.initialize());

    }

    initialize() {
        const self = this; //need to create a reference for the parent to be able to call it from a sub function.

        if (this.state.user != undefined && this.state.baseApi != undefined) {
            this.setState({
                loading: true
            });
            var isIframe = (this.props.location.state != undefined && this.props.location.state.isIframe != undefined && this.props.location.state.isIframe === true);
            var contactID = isIframe ? this.props.location.state.clientID : null;
            if (isIframe && contactID != null)
                this.createInteractionThread(this.state.user.userID, contactID, () => { this.getInteractionThreads(); });
            else
                this.getInteractionThreads();
            
            
        }
        var pusher = new Pusher(this.state.pusherKey, {
            cluster: this.state.pusherCluster,
            forceTLS: true
        });


        var channel = pusher.subscribe('cc-' + self.state.user.userID);

        channel.bind('new-message', function (data) {
            //alert(JSON.stringify(data));
            self.fetchThreads(self.state.user.userID)

            if (data.interactionThread.InteractionThreadID === self.state.interactionThreadId) {
                self.fetchMessages(data.interactionThread.InteractionThreadID, self.state.currentThread)
            }
        });

        channel.bind('new-thread', function (data) {
            //alert(JSON.stringify(data));
            self.fetchThreads(self.state.user.userID);
            self.chooseThread(data.interactionThread.InteractionThreadID, data.interactionThread);

        });

        channel.bind('fetch-threads', function (data) {
            self.fetchThreads(self.state.user.userID);
        });


        //if (isIframe) {
        //    require('../css/iframe.css');
        //}
        
    }

    getInteractionThreads() {
        this.setState({
            loading: true
        });
        fetch(this.state.baseApi + '/interaction/GetUserInteractionThreads?userID=' + this.state.user.userID)
            .then(response => response.json())
            .then(data => {

                data = toArray(data);

                this.setState(
                    {
                        allThreads: data
                    });

                if (data.length > 0) {
                    this.setState({
                        interactionThreadId: data[0].InteractionThreadID,
                        currentThread: data[0]
                    }, () => {
                        this.chooseThread(this.state.interactionThreadId, this.state.currentThread);
                    });
                }
                else
                    this.setState({
                        loading: false
                    });
            });
    }

    chooseThread(interactionThreadId, thread) {

        this.setState({
            interactionThreadId: interactionThreadId,
            currentThread: thread,
            messageList: [],
            loading: true
        }, () => {
            this.fetchMessages(interactionThreadId);
            this.markThreadAsRead(interactionThreadId, thread);
            this.getContact(thread.InteractionContactIDs != null ? thread.InteractionContactIDs[0] : -1, thread.InteractionContactType != null ? thread.InteractionContactType : -1);
        });

        const element = document.getElementById('thread-chat-list');
        element.classList.remove('show-chat-list');

    }

    hideThreadList(e) {
        const element = document.getElementById('thread-chat-list');
        element.classList.remove('show-chat-list');
    }

    scrollToBottom = () => {
        this.chatMessagesEnd.scrollIntoView({ behavior: "smooth" });
    }

    markThreadAsRead(interactionThreadId, thread) {
        var url = this.state.baseApi + '/interaction/MarkReadMessageInUserInteractionThread?userID=' + this.state.user.userID + '&interactionThreadID=' + interactionThreadId;
        fetch(url,
            {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
            });
        thread.ReadLastMessage = true;
    }

    fetchThreads = async (userId) => {

        fetch(this.state.baseApi + '/interaction/GetUserInteractionThreads?userID=' + userId)
            .then(response => response.json())
            .then(data => {
                this.setState(
                    {
                        allThreads: toArray(data),
                        loading: false
                    });
            });
    }

    fetchMessages(interactionThreadId) {

        fetch(this.state.baseApi + '/interaction/GetInteractionThreadData?interactionThreadID=' + interactionThreadId)
            .then(response => response.json())
            .then(data => {
                this.setState(
                    {
                        messageList: toArray(data),
                        loading: false
                    });
            });
    }

    sendMessage(text) {
        var newMessagelist = this.state.messageList.slice();
        newMessagelist.push({
            MessageBody: text,
            MessageDirection: 2,
            FromName: this.state.user.username,
            SentOn: new Date(),
            Loading: true
        });
        this.setState({ messageList: newMessagelist })

        var url = this.state.baseApi + '/interaction/ProcessUserTextMsg?userID=' + this.state.user.userID + '&interactionThreadID=' + this.state.interactionThreadId + '&message=' + encodeURIComponent(text);

        var interactionThreadId = this.state.interactionThreadId;

        fetch(url,
            {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },

            })
            .then(() => {
                this.fetchMessages(interactionThreadId);
                this.fetchThreads(this.state.user.userID);
            });

        this.markThreadAsRead(this.state.interactionThreadId, this.state.currentThread);
    }

    createInteractionThread(userId, memberId, callback) {
        //first search through current list if there is already an interaction thread for this member.
        if (this.state.allThreads && this.state.allThreads.length > 0) {
            var matchedThreads = this.state.allThreads.filter(thread => {
                var threadMemberID = thread.MemberIDs != null ? thread.MemberIDs[0] : -1;
                return threadMemberID === memberId;
            });

            if (matchedThreads && matchedThreads.length > 0) {
                this.chooseThread(matchedThreads[0].InteractionThreadID, matchedThreads[0]);
                if (callback != undefined && callback != null)
                    callback();
            }

        }

        this.setState({
            loading: true
        });
        var urlInteractionThread = this.state.baseApi + '/interaction/CreateInteractionThreadForUserInitiatedContact?userID=' + userId + '&memberID=' + memberId

        fetch(urlInteractionThread, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
        }).then(() => {
            this.setState({
                loading: false
            });
            if (callback != undefined && callback != null)
                callback();
        });
    }

    toggleConfirmCustomer() {
        this.setState({
            confirmMemberID: '',
            confirmFirstName: '',
            confirmLastName: '',
            confirmCellphone: '',
            showConfirmExistingCustomer: !this.state.showConfirmExistingCustomer
        });
    }


    confirmMember() {
        this.createInteractionThread(this.state.user.userID, this.state.confirmMemberID)
    }



    addContact(firstname, lastname, cellphone) {
        cellphone = cellphone.replace(/\D/g, '');
        const self = this;
        var userID = this.state.user.userID;
        var username = this.state.user.username;
        var urlMember = this.state.baseApi + '/interaction/AddMemberForInteraction?userID=' + userID + '&userName=' + username + '&firstName=' + firstname + '&lastName=' + lastname + '&cellphone=' + cellphone;

        this.setState({
            loading: true
        })

        fetch(urlMember,
            {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },

            })
            .then(response => response.json())
            .then(data => {

                if (!data.MemberAlreadyExists && data.MemberID > 0) {
                    self.createInteractionThread(userID, data.MemberID);
                }
                else {
                    self.setState({
                        confirmMemberID: data.MemberID,
                        confirmFirstName: data.FirstName,
                        confirmLastName: data.LastName,
                        confirmCellphone: data.Member.CellPhone,
                        confirmCreatedDate: data.Member.CreatedDate,
                        showConfirmExistingCustomer: true,
                        loading: false
                    });
                }

            });
    }

    editContact(contactID, contactType, firstname, lastname, cellphone) {
        cellphone = cellphone.replace(/\D/g, '');
        const self = this;
        var userID = this.state.user.userID;
        var urlMember = this.state.baseApi + '/interaction/UpdateInteractionContact?userID=' + userID + '&contactType=' + contactType + '&contactID=' + contactID + '&firstname=' + firstname + '&lastname=' + lastname + '&cellphone=' + cellphone;

        this.setState({
            loading: true
        })

        fetch(urlMember,
            {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },

            })
            .then(response => response.json())
            .then(data => {

                self.setState({
                    memberDetail: data,
                    loading: false
                });

                this.getConfig().then(() => this.initialize());


                self.fetchThreads(self.state.user.userID).then(() => {
                    var updatedthread = self.state.allThreads.find(x => x.InteractionThreadID === self.state.interactionThreadId);
                    self.chooseThread(self.state.interactionThreadId, updatedthread);
                });

            });
    }




    deleteChat(interactionThreadID) {
        var userID = this.state.user.userID;
        const self = this;

        var urlDeleteInteractionThread = this.state.baseApi + '/interaction/DeleteInteractionThreadUserMap?interactionThreadID=' + interactionThreadID + '&userID=' + userID;
        this.setState({
            loading: true
        })

        fetch(urlDeleteInteractionThread,
            {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },

            })
            .then(() => {

                self.setState({
                    interactionThreadId: null,
                    messageList: [],
                    currentThread: null,
                    loading: false
                });

            });
    }

    getContact(interactionContactID, contactType) {
        //member
        if (interactionContactID > 0) {
            const self = this;
            var urlMember = this.state.baseApi + '/interaction/GetInteractionContact?interactionContactID=' + interactionContactID + '&interactionContactType=' + contactType;

            this.setState({
                loading: true
            })

            fetch(urlMember,
                {
                    method: 'get',
                    headers: { 'Content-Type': 'application/json' },

                })
                .then(response => response.json())
                .then(data => {
                    //self.props.loading = false;

                    self.setState({
                        loading: false,
                        memberDetail: data
                    });

                });


        }
    }


    render() {

        var isiFrame = (this.props.location.state != undefined && this.props.location.state.isIframe != undefined && this.props.location.state.isIframe === true);
        // isiFrame = true; // LOCALHOST TESTING ONLY

        var boxTypicalStyle = {

        }

        if (isiFrame) {
            boxTypicalStyle = {
                margin: "0"
            }
        }

        return (
            <Loader show={this.state.loading} message={'loading'}>
                <Layout isIframe={isiFrame}>
                    <div className="box-typical chat-container" style={boxTypicalStyle} onClick={() => this.hideThreadList()}>
                        <ThreadList
                            chooseThread={this.chooseThread}
                            threadList={this.state.allThreads}
                            selectedInteractionThreadId={this.state.interactionThreadId}
                            editContact={this.editContact}
                            addContact={this.addContact}
                            user={this.state.user}
                            baseApi={this.state.baseApi}
                            createInteractionThread={this.createInteractionThread}
                            isIframe={isiFrame}
                        />
                        <Chat
                            sendMessage={this.sendMessage}
                            deleteChat={this.deleteChat}
                            thread={this.state.currentThread}
                            messageList={this.state.messageList}
                            memberDetail={this.state.memberDetail}
                            user={this.state.user}
                            baseApi={this.state.baseApi}
                            parentAppBaseUrl={this.state.parentAppBaseUrl}
                            createInteractionThread={this.createInteractionThread}
                            isIframe={isiFrame}
                        />
                        <ConfirmExistingCustomer user={this.props.user} isOpen={this.state.showConfirmExistingCustomer} firstname={this.state.confirmFirstName} lastname={this.state.confirmLastName} cellphone={this.state.confirmCellphone} createddate={this.state.confirmCreatedDate} toggle={this.toggleConfirmCustomer} confirmMember={this.confirmMember} />
                    </div>
                </Layout>
            </Loader>
        );
    }
}
